<!-- <app-header></app-header> -->
<div class='c'>
    <div class='_404'>404</div>
    <div class='_1'>THE PAGE</div>
    <div class='_2'>WAS NOT FOUND</div>
    <a class='btn' routerLink="/" style="margin-top:2rem">GO BACK TO HOME</a>
</div>
<!-- <app-footer></app-footer> -->

